import { useMutation, useQuery } from '@apollo/client/react';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { withTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Card from '../../components/Atoms/Card';
import Error from '../../components/Atoms/Error';
import Heading from '../../components/Atoms/Heading';
import Loader from '../../components/Atoms/Loader';
import CalendarEventForm from '../../components/Forms/CalendarEventForm';
import { useLayoutInfo } from "../../hooks/useLayoutUpdate";

import CalendarEventMutationGQL from './CreateCalendarEventMutation.graphql';
import GetCalendarInformationsQueryGQL from './GetCalendarInformationsQuery.graphql';

export const CalendarEventView = ({ t }) => {
  
  useLayoutInfo({
    title: t('Create a calendar event'),
    history: [{ title: t('Calendar'), action: '/calendar/' }, { title: t('Create') }],
  });

  const { loading, error, data } = useQuery(GetCalendarInformationsQueryGQL);
  const [calendarEventMutation, { loading: mutationLoading }] = useMutation(CalendarEventMutationGQL);
  const navigate = useNavigate();

  const onCalendarEvent = async (data) => {
    await calendarEventMutation({
      variables: {
        input: data,
      },
    });
    navigate(`/calendar/`);
  };

  if (loading) return <Loader />;
  if (error) return <Error icon={faTriangleExclamation} message={t('An error occurred while loading the calendar informations.')} />;

  return (
    <>
      <Card>
        <Heading h="1">{t('New calendar event')}</Heading>
        <CalendarEventForm
          contests={data.contests.edges.map(c => ({
            value: c.node.id,
            label: c.node.title
          }))}
          communities={data.websites.edges.map(c => ({
            value: c.node.id,
            label: c.node.name
          }))}
          onSubmit={onCalendarEvent}
          loading={mutationLoading}
          buttonLabel={t('Create an event')} />
      </Card>
    </>
  );
};

export default withTranslation()(CalendarEventView);
